<!-- 理光实物审批 -->
<template>
	<div class="process-page">
		<!-- 机器零件信息 -->
		<div class="create-section">
			<h3>{{ partTitleObj[repairType] }}信息</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsNumberNew != null">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}新编号</p>
							<p class="content">{{ part.partsNumberNew }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsBatchNumber != null">
						<div class="info-box">
							<p class="title">批号</p>
							<p class="content">{{ part.partsBatchNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
					</div>
					<div class="t-r mt10">
						<el-button type="primary" size="small" @click="handleUpdatePart(part.id)">编辑新编号</el-button>
					</div>
				</div>
				<div class="flex-1 part-info-box-right">
					<div class="right-item">实物检测结果： 同意</div>
					<div class="right-item">零件索赔进度： {{ part.auditStatus == 1 ? "实物审批已通过" : "无货等待" }}</div>
					<div class="right-item" v-if="part.auditStatus == 2">预计发货时间： {{ part.estimatedShippingTime }}</div>
					<div class="right-item word-bread-all" v-if="part.auditStatus == 2">发货批注： {{ part.currentAudit.remark }}</div>
					<div class="right-item">
						执行操作：
						<el-radio v-model="part.opType" label="1" v-if="part.auditStatus == 1">无货等待</el-radio>
						<el-radio v-model="part.opType" label="2">索赔发货</el-radio>
						<el-radio v-model="part.opType" label="3">拒绝发货</el-radio>
					</div>
					<div class="right-item" v-if="part.opType">
						{{ part.opType == "3" ? "拒绝理由" : "审批批注" }}
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="part.auditRemarks"></el-input>
					</div>
					<div class="right-item" v-if="part.opType == '1'">
						预计发货时间:
						<br />
						<el-date-picker
							v-model="part.estimatedShippingTime"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="date"
							:picker-options="pickerOptions1"
							placeholder="请选择预计发货时间"></el-date-picker>
					</div>
					<div class="right-item" v-if="part.opType == '2'">
						发货订单号
						<el-input placeholder="请输入内容" v-model="part.shippingOrderNo"></el-input>
					</div>
					<div class="right-item" v-if="part.opType == '2'">
						请填写索赔件实际发货时间
						<br />
						<el-date-picker
							v-model="part.actualShippingTime"
							type="datetime"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							:picker-options="pickerOptions"
							placeholder="请选择日期时间"></el-date-picker>
					</div>
					<div class="right-item" v-if="part.opType == '2'">
						<el-button type="info" @click="handleAddressInfo(part.id)">填写索赔发货信息</el-button>
					</div>
					<div class="right-item t-r" v-if="part.opType">
						<el-button type="primary" @click="handleSubmit(part)">提交</el-button>
					</div>
				</div>
			</div>
			<div class="report-book-box" v-if="repairType == '1'">
				<h2>现场技术问题报告书</h2>
				<FileList :file-list="issueReportFileIdList" class="mt4"></FileList>
			</div>
			<div class="report-book-box" v-if="repairType == '2'">
				<h2>ACR&零件事故报告书</h2>
				<FileList :file-list="acrReportFileIdList" class="mt4"></FileList>
			</div>
			<div class="report-book-box" v-if="repairType == '3'">
				<h2>商品问题报告书</h2>
				<FileList :file-list="issueReportFileIdList" class="mt4"></FileList>
			</div>
			<div class="report-book-box" v-if="repairType == '3'">
				<h2>退换机申请书</h2>
				<FileList :file-list="returnExchangeFileIdList" class="mt4"></FileList>
			</div>
		</div>
		<UpdatePart ref="updatePart" @refresh="getInfo"></UpdatePart>
		<AddressInfo ref="addressInfo" @refresh="setFaultyExpress"></AddressInfo>
		<!-- 流程信息 -->
		<CommonCollapse1 ref="collapse1" v-if="repairType == 1" />
		<CommonCollapse2 ref="collapse2" v-if="repairType == 2" />
		<CommonCollapse3 ref="collapse3" v-if="repairType == 3" />
	</div>
</template>
<script>
import { processInfo, claimOrdersInfo, claimMaterialProcessInfo } from "@/api/claim";
import FileList from "../components/FileList.vue";
import UpdatePart from "../components/updatePartNumber.vue";
import AddressInfo from "../components/addressInfo.vue";
import CommonCollapse1 from "../components/CommonCollapse1.vue";
import CommonCollapse2 from "../components/CommonCollapse2.vue";
import CommonCollapse3 from "../components/CommonCollapse3.vue";
import { debounce } from "@/utils/debounce";
export default {
	components: {
		FileList,
		UpdatePart,
		AddressInfo,
		CommonCollapse1,
		CommonCollapse2,
		CommonCollapse3,
	},
	data() {
		return {
			repairType: "",
			partsDetailList: [],
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			issueReportFileIdList: [],
			acrReportFileIdList: [],
			returnExchangeFileIdList: [],
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			submitTime: "",
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
			pickerOptions1: {
				disabledDate: (time) => {
					// 禁用今天之前的日期（只能选今天及之后）
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 确保今天 00:00:00 开始
					return time.getTime() < today.getTime();
				},
			},
			createTime: "",
		};
	},
	mounted() {
		// 获取单个索赔信息
		this.getInfo();
	},
	methods: {
		getInfo() {
			const claimId = sessionStorage.getItem("claimId");
			const repairType = sessionStorage.getItem("repairType");
			if (repairType == "1") {
				this.getClaimWarrantyInfo(claimId);
			} else if (repairType == "2") {
				this.getClaimOrdersInfo(claimId);
			} else {
				this.getClaimMaterialInfo(claimId);
			}
		},
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			processInfo(claimId, true)
				.then((r) => {
					self.repairType = r.data.repairType;
					self.innerAdvanceCode = r.data.partsClaimWarranty.innerAdvanceCode;
					self.applyAdvanceCode = r.data.partsClaimWarranty.applyAdvanceCode;
					self.issueReportFileIdList = [...r.data.partsClaimWarranty.issueReportFileList];
					// partsDetailList
					let array = [];
					for (const element of r.data.partsDetailList) {
						if ([1, 2].includes(element.currentAudit.auditStatus)) {
							// 1无货等待 2索赔发货 3拒绝发货
							// element.currentAudit.auditStatus == 1 ? (element.opType = "1") : (element.opType = "2");
							element.opType = "";
							element.currentAudit.auditStatus == 1 ? (element.estimatedShippingTime = "") : "";
							element.actualShippingTime = "";
							element.shippingOrderNo = "";
							element.auditRemarks = "";
							element.auditStatus = element.currentAudit.auditStatus;
							array.push(element);
						}
					}
					self.partsDetailList = [...array];
					self.submitTime = r.data.submitTime;
					self.createTime = r.data.currentAudit.createTime;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaimOrdersInfo(claimId) {
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.repairType = r.data.repairType;
						self.innerAdvanceCode = r.data.partsClaimOrders.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimOrders.applyAdvanceCode;
						self.acrReportFileIdList = [...r.data.partsClaimOrders.acrReportFileList];
						// partsDetailList
						let array = [];
						for (const element of r.data.partsDetailList) {
							if ([1, 2].includes(element.currentAudit.auditStatus)) {
								// 1无货等待 2索赔发货 3拒绝发货
								// element.currentAudit.auditStatus == 1 ? (element.opType = "1") : (element.opType = "2");
								element.opType = "";
								element.currentAudit.auditStatus == 1 ? (element.estimatedShippingTime = "") : "";
								element.actualShippingTime = "";
								element.shippingOrderNo = "";
								element.auditRemarks = "";
								element.auditStatus = element.currentAudit.auditStatus;
								array.push(element);
							}
						}
						self.partsDetailList = [...array];
						self.submitTime = r.data.submitTime;
						self.createTime = r.data.currentAudit.createTime;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaimMaterialInfo(claimId) {
			let self = this;
			claimMaterialProcessInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.repairType = r.data.repairType;
						self.innerAdvanceCode = r.data.partsClaimMaterial.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimMaterial.applyAdvanceCode;
						self.issueReportFileIdList = [...r.data.partsClaimMaterial.issueReportFileList];
						self.returnExchangeFileIdList = [...r.data.partsClaimMaterial.returnExchangeFileList];
						// partsDetailList
						let array = [];
						for (const element of r.data.partsDetailList) {
							if ([1, 2].includes(element.currentAudit.auditStatus)) {
								// 1无货等待 2索赔发货 3拒绝发货
								// element.currentAudit.auditStatus == 1 ? (element.opType = "1") : (element.opType = "2");
								element.opType = "";
								element.currentAudit.auditStatus == 1 ? (element.estimatedShippingTime = "") : "";
								element.actualShippingTime = "";
								element.shippingOrderNo = "";
								element.auditRemarks = "";
								element.auditStatus = element.currentAudit.auditStatus;
								array.push(element);
							}
						}
						self.partsDetailList = [...array];
						self.submitTime = r.data.submitTime;
						self.createTime = r.data.currentAudit.createTime;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 提交
		handleSubmit: debounce(function (part) {
			if (part.opType == "") {
				this.$message.error(`请选择执行操作`);
				return;
			}
			// 发货时间不能早于工单开始时间
			// 无货等待
			if (part.opType == "1") {
				if (part.estimatedShippingTime == "") {
					this.$message.error(`请选择预计发货时间`);
					return;
				}
				const params = {
					id: part.id,
					estimatedShippingTime: part.estimatedShippingTime,
					auditRemarks: part.auditRemarks,
				};
				this.updateWarranty("partSubmitWaiting", params);
			}
			// 索赔发货
			else if (part.opType == "2") {
				if (part.shippingOrderNo == "") {
					this.$message.error(`请输入发货订单号`);
					return;
				}
				if (part.actualShippingTime == "") {
					this.$message.error(`请选择实际发货时间`);
					return;
				}
				if (part.actualShippingTime < this.createTime) {
					this.$message.error(`索赔件实际发货时间不能早于实物审批时间${this.createTime}`);
					return;
				}
				if (part.partsClaimExpress == null) {
					this.$message.error(`请填写索赔发货信息`);
					return;
				}
				const params = {
					id: part.id,
					actualShippingTime: part.actualShippingTime,
					shippingOrderNo: part.shippingOrderNo,
					auditRemarks: part.auditRemarks,
				};
				this.updateWarranty("partSubmitShipping", params);
			}
			// 拒绝发货
			else {
				if (part.auditRemarks == "") {
					this.$message.error(`请输入拒绝理由`);
					return;
				}
				const params = {
					id: part.id,
					auditRemarks: part.auditRemarks,
				};
				this.updateWarranty("partSubmitRefuse", params);
			}
		}, 1000),
		// 提交接口
		updateWarranty(postUrl, params) {
			let self = this;
			self.$request.post(postUrl, true, params, function (r) {
				if (r.code == "0") {
					self.$message({
						message: "操作成功",
						type: "success",
					});
					if (postUrl == "partSubmitWaiting") {
						self.getInfo();
					} else {
						let array = [];
						for (const element of self.partsDetailList) {
							if (element.id != params.id) {
								array.push(element);
							}
						}
						if (array.length == 0) {
							self.$router.push({
								name: "claimDeliveryList",
							});
						} else {
							self.partsDetailList = array;
							if (self.repairType == "1") {
								self.$refs.collapse1.getInfo();
							} else if (self.repairType == "2") {
								self.$refs.collapse2.getInfo();
							} else if (self.repairType == "3") {
								self.$refs.collapse3.getInfo();
							}
						}
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 新增零件
		handleUpdatePart(id) {
			this.$refs.updatePart.init(id);
		},
		// 地址信息
		handleAddressInfo(id) {
			this.$refs.addressInfo.init({
				id: id,
				linkTable: "parts_claim_detail",
				expressType: "3",
				applyAdvanceCode: this.applyAdvanceCode,
				innerAdvanceCode: this.innerAdvanceCode,
			});
		},
		// 设置faultyExpress
		setFaultyExpress(id, partsClaimExpress) {
			for (const element of this.partsDetailList) {
				if (element.id == id) {
					element.partsClaimExpress = partsClaimExpress;
				}
			}
		},
		disabledDate(time) {
			// 设置最小日期为 2025-04-27 08:13:08
			const minDate = new Date(this.submitTime);
			return time.getTime() < minDate.getTime();
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
	min-width: 0;
	word-wrap: break-word;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
	}
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.t-r {
	text-align: right;
}
.mt10 {
	margin-top: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
.report-book-box {
	margin-top: 20px;
	margin-bottom: 20px;
	h2 {
		margin-bottom: 10px;
	}
	.title1 {
		font-size: 14px;
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		margin-top: 5px;
		margin-bottom: 10px;
	}
}
.tips {
	font-size: 13px;
	color: #909399;
}
.word-bread-all {
	white-space: pre-line;
	word-break: break-all;
}
</style>
